module.exports = __webpack_public_path__ + "static/img/KPL.4d9e203.png";


//////////////////
// WEBPACK FOOTER
// ./static/seriesPic/KPL.png
// module id = AdFw
// module chunks = 1